var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapModal"},[_c('div',{staticClass:"mapImg",style:({
      backgroundImage:
        'url(' +
        require('@/assets/images/StIves/maps/map' + (_vm.Selected + 1) + '.png') +
        ')',
    })},[_c('div',{staticClass:"modalCloseButton top",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }